import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import { Environment } from '../../../shared/environment';

interface IFabricaImpressao{
  idfabrica: string;
	nome: string;
	logo: string;
  itens: IItensImpressao[];
}

interface IItensImpressao{
 	descricao: string;
	quantidade: number;
	un: string;
	preco: number;
	total: number;
  ean: string;
  nome: string;
}

interface IImpressao{
   nome: string;
   cpf: string;
   rg: string;
   cep: string;
   endereco: string;
   bairro: string;
   municipio: string;
   uf: string;
   telefone: string;
   descricao: string;
   emissao: Date;
   numero: number;
   valor: number;
   fabricas: IFabricaImpressao[];
}
 
async function PDFPedidos(dados: IImpressao){

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  process.env.REACT_APP_URL_IMAGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  let qtd = 0;
  let totalGeral = 0;

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const documentDefinition : any = {
 
    content: [
      {
        style: 'tableExample',
        table: {
          margin: [0, 0, 0, 0],
          widths: [148, 580],
          body: [
            [ 
              {
                margin: [0, 20, 0, 0],
                image: imageData,
                width: 148,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],
                table: {
                  widths: [180, 5, 164],    
                  body: [
                    [ 
                      {text: 'PRONTA ENTREGA', fontSize: 22, colSpan: 2,  margin: [0, 5, 0, 0], bold: true,  alignment: 'left', border: [false, false, false, false]},
                      {text: '', border: [false, false, false, false]},
                      {text: '', border: [false, false, false, false]},
                    ],
                    [ 
                      {text: '(71)98179-1818', fontSize: 20, bold: true, margin: [0, 5, 0, 0]},
                      {text: '', border: [false, false, false, false]},
                      {text: dados.descricao+ '  '+dados.numero, fontSize: 20, bold: true, margin: [0, 5, 0, 0],},
                    ],
                   
                  ]
                }
              }
            ],
          ]
        }
      },
      {
        style: 'tableExample',     
        table: {
          widths: [160, 120, 23, 95, 95],
          body: [
            [ {text: 'RAZAO SOCIAL / NOME\n'+ dados.nome, colSpan: 2, fontSize: 10, alignment: 'left', border: [true, true, false, false] },
              {text: '', border: [false, true, true, false]},
              {text: '', border: [false, true, true, true]},    
              {text: 'CPF / CNPJ\n'+ (dados.cpf.length == 11 ? (  
                dados.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
              ) : (
                dados.cpf.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
              )), fontSize: 10, alignment: 'left', }, 
              {text: 'Data Emissão\n'+ moment(dados.emissao).format('DD/MM/YYYY'), fontSize: 10, alignment: 'left', },
            ],
            [ {text: 'Endereço\n'+dados.endereco, colSpan: 2, fontSize: 10, alignment: 'left', border: [true, true, false, false]  },
              {text: '', border: [false, true, true, false]},
              {text: '', border: [false, true, true, true]},  
              {text: 'CEP\n'+dados.cep, fontSize: 10, alignment: 'left', }, 
              {text: 'Data Saida / Entrada\n '+ moment(dados.emissao).format('DD/MM/YYYY'), fontSize: 10, alignment: 'left', },
            ],
            [ {text: 'Municipio\n'+dados.municipio, fontSize: 10, alignment: 'left', },
              {text: 'Bairro\n'+dados.bairro, fontSize: 10, alignment: 'left',},
              {text: 'UF\n'+ dados.uf, fontSize: 10, alignment: 'left', }, 
              {text: 'Fone / Celular\n '+ dados.telefone, fontSize: 10, alignment: 'left', },
              {text: 'Insc. Estadual Nº\n '+ dados.rg, fontSize: 10, alignment: 'left', },
            ],
          ]
        }
      },
      await Promise.all(
        dados.fabricas.flatMap(async (e) => {
          const { itens } = e;
          const imageData1 = await getBase64ImageFromUrl(Environment.URL_IMGFABRICA + (e.logo || ''));
          const TProdutos = itens.reduce((acc, item) => acc + (item.quantidade || 0), 0);
          const Ttotal = itens.reduce((acc, item) => acc + (item.total || 0), 0);
          totalGeral += Ttotal;
          qtd = qtd + TProdutos;
          const rows = itens.map((row) => [
            { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(row.quantidade), alignment: 'right', fontSize: 9 },
           
            { text: row.ean, alignment: 'left', fontSize: 9 },
            { text: row.descricao, alignment: 'left', fontSize: 9 },
            { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(row.preco), alignment: 'right', fontSize: 9 },
            { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(row.total), alignment: 'right', fontSize: 9 },
          ]);
          
          return [
            {     
              table: {
                widths: [48, 580],
                body: [
                  [
                    { image: imageData1, width: 50, margin: [15, 0, 0, 0], fontSize: 8, border: [false, false, false, false], alignment: "left" },
                    { text: e.nome, fontSize: 16, bold: true, margin: [15, 5, 0, 0], border: [false, false, false, false] },
                  ],
                ],  
              },
            },
            {
              table: {
                widths: [50 ,80 ,254 ,55, 55],
                body: [
                  [
                    { text: 'Quantidade', alignment: 'center', fillColor: '#dddddd', fontSize: 9 },
                    { text: 'Código Barra', alignment: 'center', fillColor: '#dddddd', fontSize: 9 },  
                    { text: 'Descrição', alignment: 'left', fillColor: '#dddddd', fontSize: 9 },
                    { text: 'Preço Unt.', alignment: 'right', fillColor: '#dddddd', fontSize: 9 },
                    { text: 'Total', alignment: 'right', fillColor: '#dddddd', fontSize: 9 },
                  ],
                  ...rows,
                ],
              },
            },
            {
              table: {
                widths: [50, 80, 254, 50, 50],
                body: [
                  [
                    { text: 'Total de Itens:  '+ new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(TProdutos), 
                       alignment: 'left', colSpan: 2, fontSize: 9, border: [false, false, false, true] },
                    { text: '', alignment: 'center',  fontSize: 9, border: [false, false, false, true] },
                   
                    { text: '', alignment: 'left', fontSize: 9, border: [false, false, false, true] },
                    { text: 'Total', alignment: 'right', border: [false, false, false, true],  fontSize: 9 },
                    { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(Ttotal), 
                     alignment: 'right', fontSize: 9, border: [false, false, false, true] },
                  ],
                ],
              },
            },
            
          ];
        })
      ),
      {
        margin: [0, 10, 0, 0], // Ajuste as margens conforme necessário
        table: {
          widths: ['*', '*'], // Duas colunas com largura igual
          body: [
            [
              { 
                text: `Total Geral de Itens: ${new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(qtd)}`,
                fontSize: 9,
                bold: true,
                alignment: 'left',
                border: [false, false, false, false]
              },
             
            ]
          ]
        }
      },
      // Signature lines moved to the end of the document
      {
        margin: [30, 40, 0, 5],  
        table: {
          widths: [160, 120, 160],
          body: [
            
            [
              { text: 'Vendedor',  border: [false, true, false, false], bold: true, alignment: 'center',  fontSize: 9 },
              { text: '',  border: [false, false, false, false],  fontSize: 9 },
              { text: 'Cliente',  border: [false, true, false, false], bold: true, alignment: 'center',  fontSize: 9 },
            ],
          ],
        },       
      },
    ],
  
  };
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default PDFPedidos;